import { render, staticRenderFns } from "./SingleSalesView.vue?vue&type=template&id=f46196fe&"
import script from "./SingleSalesView.vue?vue&type=script&lang=js&"
export * from "./SingleSalesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports